module.exports = __webpack_public_path__ + "static/media/hospital.923ee17d.jpg";